import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import * as moment from 'moment/moment';
import { TimePickerCustomTheme } from 'src/app/config';
import { TIMEZONES } from 'src/assets/timezones/timezones';

@Component({
  selector: 'app-turns-desk-new-schedule-creation-card',
  templateUrl: './turns-desk-new-schedule-creation-card.component.html',
  styleUrls: ['./turns-desk-new-schedule-creation-card.component.scss']
})
export class TurnsDeskNewScheduleCreationCardComponent implements OnInit, OnDestroy {

  timezones;
  TimePickerCustomTheme: NgxMaterialTimepickerTheme;
  addNewDeskScheduleSubscription: Subscription;
  showingAfternoon: boolean;

  basicDataForm = new FormGroup({
    name: new FormControl('', Validators.required),
    openingService: new FormControl(true),
    dateFrom: new FormControl(null, Validators.required),
    dateTo: new FormControl(null, Validators.required),
    morningFrom: new FormControl(null),
    morningTo: new FormControl(null),
    afternoonFrom: new FormControl(null),
    afternoonTo: new FormControl(null),
    monday: new FormControl(true),
    tuesday: new FormControl(true),
    wednesday: new FormControl(true),
    thursday: new FormControl(true),
    friday: new FormControl(true),
    saturday: new FormControl(true),
    sunday: new FormControl(true),
    allday: new FormControl(true),
    timeZone: new FormControl('Europe/Madrid')
  });

  constructor(private desksTurnsService: DesksTurnsService,
    private userStorageService: UserStorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService) {
      this.timezones = TIMEZONES;
      this.TimePickerCustomTheme = TimePickerCustomTheme;
    }

  ngOnInit() { }

  public addSchedule() {
    if (this.basicDataForm.get('allday').value) {
      this.basicDataForm.patchValue({
        morningFrom: '00:01',
        morningTo: '23:59',
        afternoonFrom: null,
        afternoonTo: null
      });
    }
    const validation = this.validateForm();
    if (validation === true) {
      const relatedEntityInternalId = this.activatedRoute.snapshot.params['deskid'];
      const morningFrom = moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').minutes() * 60000;
      const morningTo =  moment(this.basicDataForm.get('morningTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningTo').value, 'hh:mm').minutes() * 60000;
      const afternoonFrom = moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').minutes() * 60000;
      const afternoonTo = moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').minutes() * 60000;
      this.addNewDeskScheduleSubscription = this.desksTurnsService.addNewDeskSchedule(relatedEntityInternalId, this.basicDataForm.get('monday').value, this.basicDataForm.get('tuesday').value, this.basicDataForm.get('wednesday').value, this.basicDataForm.get('thursday').value, this.basicDataForm.get('friday').value, this.basicDataForm.get('saturday').value, this.basicDataForm.get('sunday').value, morningFrom, morningTo, afternoonFrom, afternoonTo, this.basicDataForm.get('dateFrom').value.valueOf(), this.basicDataForm.get('dateTo').value.valueOf(), this.basicDataForm.get('openingService').value, this.basicDataForm.get('name').value, this.basicDataForm.get('timeZone').value).subscribe(
        (res) => {
          this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
          this.router.navigate(['../'], {relativeTo: this.activatedRoute.parent});
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'schedule-page.snackbar messages.name required';
    } else if (!this.basicDataForm.get('dateFrom').valid) {
      return 'schedule-page.snackbar messages.dateFrom required';
    } else if (!this.basicDataForm.get('dateTo').valid) {
      return 'schedule-page.snackbar messages.dateTo required';
    } else if (!this.basicDataForm.get('allday').value && !(this.basicDataForm.get('morningFrom').value && this.basicDataForm.get('morningTo').value) && !(this.basicDataForm.get('afternoonFrom').value && this.basicDataForm.get('afternoonTo').value)) {
      return 'schedule-page.snackbar messages.at least one interval';
    } else if (moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningFrom').value, 'hh:mm').minutes() * 60000 > moment(this.basicDataForm.get('morningTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('morningTo').value, 'hh:mm').minutes() * 60000) {
      return 'schedule-page.snackbar messages.from hour greater than to hour';
    } else if (this.showingAfternoon && (moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonFrom').value, 'hh:mm').minutes() * 60000 > moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').hour() * 3600000 + moment(this.basicDataForm.get('afternoonTo').value, 'hh:mm').minutes() * 60000)) {
      return 'schedule-page.snackbar messages.from hour greater than to hour';
    } else {
      return true;
    }
  }

  public alldayChanged() {
    if (this.basicDataForm.get('allday').value) {
      this.basicDataForm.patchValue({
        morningFrom: '00:00',
        morningTo: '23:59',
        afternoonFrom: null,
        afternoonTo: null
      });
    } else {
      this.basicDataForm.patchValue({
        morningFrom: null,
        morningTo: null,
        afternoonFrom: null,
        afternoonTo: null
      });
    }
  }

  public clearField(fieldName) {
    this.basicDataForm.patchValue({
      [fieldName]: null
    });
  }

  public showAfternoon() {
    this.showingAfternoon = !this.showingAfternoon;
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  ngOnDestroy() {
    if (this.addNewDeskScheduleSubscription) { this.addNewDeskScheduleSubscription.unsubscribe(); }
  }
}
